import React,{useEffect} from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import M from 'materialize-css/dist/js/materialize.min.js';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './store/store';
import Home from './components/Home';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import PortalPage from './components/PortalPage';
import ResetPage from './components/ResetPage';
import ConfirmDelete from './components/ConfirmDelete';
import TeachHome from './components/TeachHome';
import TeachAccountAdded from './components/TeachAccountAdded';

const App = () => {
  useEffect(()=>{
    M.AutoInit();
  },[]);

  return (
    <Provider store={store}>
        <ConfirmDelete />
        <BrowserRouter>
          <Switch>
            <Route exact path='/' component={Home} />
            <Route exact path='/portaluserlogin' component={Login} />
            <Route exact path='/teachadminlogin' component={Login} />
            <Route exact path='/portalresetpassword' component={ResetPage} />
            <PrivateRoute exact path='/portaluserpage' component={PortalPage} />
            <PrivateRoute exact path='/teachadminhome' component={TeachHome} />
            <PrivateRoute exact path='/teachaccountadded' component={TeachAccountAdded} />
            <Route render={()=><h3>404 page not found</h3>} />
          </Switch>
        </BrowserRouter>
    </Provider>
  );
};
export default App;
